import { ClassValue } from 'clsx';
import { View } from '@shared/components/View';
import { GRID_UNIT } from '@shared/styles/constants';
import { grid } from '@shared/styles/grid';
import { Icon } from './Icon';
import { IconName } from './iconNameMap';
import styles from './IconAvatar.module.css';

export interface IconAvatarProps {
  name?: IconName;
  /** Diameter of the circle in px. */
  size?: number;
  iconGridSize?: number;
  color?: string;
  backgroundColor?: string;
  className?: ClassValue;
  testID?: string;
}

const DEFAULT_AVATAR_SIZE = grid(6);
const INSET_RATIO = 0.1;

/**
 * An `Icon` centred in a filled circle. Colors default to the theme's avatar
 * foreground and background.
 */
export function IconAvatar({
  name,
  size = DEFAULT_AVATAR_SIZE,
  iconGridSize = (size - 2 * Math.round(size * INSET_RATIO)) / GRID_UNIT,
  color,
  backgroundColor,
  className,
  testID,
}: IconAvatarProps) {
  return (
    <View
      center
      className={[styles.iconAvatar, className]}
      vars={{ size, color, backgroundColor }}
      testID={testID}
    >
      <Icon name={name} gridSize={iconGridSize} />
    </View>
  );
}
